/**
 * External Dependencies
 */
import 'jquery';
import Swiper from 'swiper/bundle';
import * as Cookies from "js-cookie";

$(document).ready(() => {
  // console.log('Hello world');
});

// Swiper
const swiper = new Swiper('.swiper-container', {
  slidesPerView: "auto",
  spaceBetween: 12,
  freeMode: true,
});

// Tabs
const tabs = document.querySelectorAll(".my-tabs .tabs li");
const sections = document.querySelectorAll(".my-tabs .tab-content");

tabs.forEach(tab => {
  tab.addEventListener("click", e => {
    e.preventDefault();
    removeActiveTab();
    addActiveTab(tab);
  });
})

const removeActiveTab = () => {
  tabs.forEach(tab => {
    tab.classList.remove("is-active");
  });
  sections.forEach(section => {
    section.classList.remove("is-active");
  });
}

const addActiveTab = tab => {
  tab.classList.add("is-active");
  const href = tab.querySelector("a").getAttribute("href");
  const matchingSection = document.querySelector(href);
  matchingSection.classList.add("is-active");
}

$(document).ready(function() {
  var cookie = Cookies.get('modal');
  var element = document.getElementById("modal");
  if (cookie == null && element) {
    element.classList.remove("hidden");
    Cookies.set('modal', 'show', { expires: 1 });
  }
});

// Modal
$('.close-modal').on('click', function() {
  $('#modal').addClass('hidden');
});

// Google Map
(function( $ ) {

  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */

  function initMap( $el ) {
  
    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom : $el.data('zoom') || 16,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },  
        mapId: '3ec63f434d51614b'
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
  }
  
  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */

  var infoWindows = [];

  function initMarker( $marker, map ) {
  
      // Get position from marker.
      var lat = $marker.data('lat');
      var lng = $marker.data('lng');
      var latLng = {
          lat: parseFloat( lat ),
          lng: parseFloat( lng )
      };
  
      // Create marker instance.
      var icon = $marker.attr('data-icon');
      var marker = new google.maps.Marker({
          position : latLng,
          map: map,
          icon: icon
      });
  
      // Append to reference for later use.
      map.markers.push( marker );
  
      // If marker contains HTML, add it to an infoWindow.
      if( $marker.html() ){

        // Create info window.
        var infoWindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        infoWindows.push(infoWindow);

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {

            //close all
            for (var i = 0; i < infoWindows.length; i++) {
                infoWindows[i].close();
            }
            infoWindow.open( map, marker );

        });

        google.maps.event.addListener(map, 'click', function() {
            infoWindow.close();
        });
      }
  }
  
  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */

  function centerMap( map ) {
  
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }

  }
  
  // Render maps on page load.
  $(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
  });
  
})(jQuery);
